/**
 * Ensures LP_RMMVP always accompanies LITPRO in reporting service calls.
 * Accepts a single edApp string or an array of edApp strings.
 *
 * @example
 * getEdApps('LITPRO')          // ['LITPRO', 'LP_RMMVP']
 * getEdApps('WORD')            // ['WORD']
 * getEdApps(['LITPRO', 'WORD']) // ['LITPRO', 'WORD', 'LP_RMMVP']
 * getEdApps(undefined)         // []
 */
export function getEdApps(edApps: string | string[] | undefined): string[] {
  if (!edApps) return [];
  const apps = Array.isArray(edApps) ? [...edApps] : [edApps];
  if (apps.includes('LITPRO') && !apps.includes('LP_RMMVP')) {
    apps.push('LP_RMMVP');
  }
  return apps;
}
